import { api } from "./api";

export const fetchProductData = async (id: any, endpoint: string) => {
  const url = endpoint + id;
  try {
    const response = await api.get(url, {
      params: {
        page: 1,
        pageSize: 10,
      },
    });
    return response.data.data.product;
  } catch (error: any) {
    console.error(
      "Error fetching products:",
      error.response?.data || error.message
    );
    throw new Error("Failed to fetch product details");
  }
};
